import { render, staticRenderFns } from "./PastEnquiryDetails.vue?vue&type=template&id=12a81ca6&scoped=true"
import script from "./PastEnquiryDetails.vue?vue&type=script&lang=js"
export * from "./PastEnquiryDetails.vue?vue&type=script&lang=js"
import style0 from "./PastEnquiryDetails.vue?vue&type=style&index=0&id=12a81ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a81ca6",
  null
  
)

export default component.exports